// modules/PageLoading.js
import React        from 'react';

const sources = require('./config.json');

class PageLoading extends React.Component {
	constructor(props) {
		super(props);
		this.loadingImage = sources.loadingimage;
	}

	render() {
		return (
			<div className="page-loading">{this.props.children} Loading<br/><br/><img src={this.loadingImage} alt="Loading..."/></div>
		);
	}
}

export default PageLoading;


/** WEBPACK FOOTER **
 ** ./src/modules/PageLoading.js
 **/